export default __webpack_public_path__ + "static/media/gradadm.3977aec4.png";